/**
 * Internal dependencies
 */
import {
    PLAN_NAMES_RECEIVE,
    PLAN_NAMES_REQUEST,
    PLAN_NAMES_REQUEST_SUCCESS,
    PLAN_NAMES_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import { getAllPlanNames, requestingPlanNames } from './selectors';

/**
 * [description]
 *
 * @return {[type]} [description]
 */
export const requestPlanNames = () => (dispatch) => {
    dispatch({
        type: PLAN_NAMES_REQUEST,
    });
    return cscom
        .planNames()
        .list()
        .then((planNames) => {
            dispatch({ type: PLAN_NAMES_REQUEST_SUCCESS });
            dispatch({ type: PLAN_NAMES_RECEIVE, payload: { items: planNames } });
            return planNames;
        })
        .catch((error) => {
            dispatch({
                type: PLAN_NAMES_REQUEST_FAILURE,
                error,
            });
        });
};

/**
 * [description]
 *
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestPlanNamesIfNotRequested = (...props) => async (dispatch, getState) => {

    const planNames = getAllPlanNames(getState());
    const requesting = requestingPlanNames(getState());

    if (Object.keys(planNames).length == 0 && requesting == false) {
        return dispatch(requestPlanNames(...props))
    }

    return planNames;
}
